export default "__VITE_ASSET__CRwCb_ry__"